import $ from 'jquery'
import { cca_config } from '../../../../../CCA_ENV_CONF/env';
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import InfoOperationRST from '@/components/caisse/factures/info-operation'
import store_patient from "@/store/mods/clinique/patients"
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import { VueEditor } from "vue2-editor"
import { minimalToolBar } from '@/utils/constants'
Vue.use(VueHtml2pdf)

export default {
    name: 'pro-facture',
    components: {
        EnteteBonEtFacture, VueHtml2pdf,
        InfoOperationRST, VueEditor
    },
    props: [],
    data() {
        return {
            save_loading: false,
            is_confirm: false,
            info_is_loading: true,
            info_error_load: false,
            est_assure: false,
            can_generate_bill: true,

            billing_operations: [],

            is_printable: false,

            toggle_payment_state: 0,

            total_net: 0,
            tot_base_assurance: 0,
            total_prix_assureur: 0,
            total_prix_assure: 0,

            info_assurance: {},
            prestations: [],
            compte_id: 0,

            water_mark_text: "DUPLICATA",
            filename: '',
            tmp_bill_date: '',

            type_factures: [],
            is_standardized: 0,

            selected_type_facture: {
                type: '',
                description: ''
            },

            selected_type_paiement: {
                type: '',
                description: ''
            },
            can_print: false,
            info_operation: {},
            patient_insurance_info: {},
            is_online: false,
            sfe_error: false,

            colspans: {
                colspan_1: '',
                colspan_2: '',
                colspan_3: '',
                colspan_4: '',
            },

            client: {
                ifu: '',
                nom_client: ''
            },
            info_client_is_empty: false,

            customToolbar: minimalToolBar,
            commentaire: '',
            placeholder: "Commentaire",
            can_add_comment: false,
            is_self_client: false,

            bill_currency_rate: 0
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        bill_selected_operations() {
            return this.$store.getters['bill_selected_operations']
        },
        
        selected_sfe_aib() {
            return this.$store.getters['selected_sfe_aib']
        },

        patient() {
            return this.$store.getters['patient']
        },
        
        sfe_type_facture() {
            return this.$store.getters['sfe_type_facture'];
        },

        sfe_type_paiement() {
            return this.$store.getters['sfe_type_paiement'];
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },
    },

    async mounted() {
        if (this.has_two_currencies) {
            this.currency_info = this.$store.getters['info_currency']
        }
        
        window.addEventListener('online', this.handleOnline);
        window.addEventListener('offline', this.handleOffline);

        this.is_online = await this.checkInternetConnection()

        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js

        if (this.patient.patient_id > 0) {
            this.getInsuranceInfo()
        }

        this.setBillingOperation()
        this.getDiversInfo()

        if (cca_config.IS_SFE) {
            // Type facture SFE
            this.getTypeFacturesSFE()

            // Type paiement SFE
            this.getTypePaiementSFE()
        }

        const tmpstamp = this.current_date.getTime()
        this.filename = 'Facture_' + this.patient.nom_patient + '_' + tmpstamp
    },

    beforeDestroy() {
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
    },

    methods: {
        getDiversInfo() {
            this.$store.dispatch('getConfigInfoClinique', 'divers_info').then(() => {
                if (this.divers_info.show_comment == 'Oui') {
                    this.can_generate_bill = false
                } else {
                    this.can_generate_bill = true

                    if (cca_config.IS_SFE) {
                        this.can_generate_bill = false
                    }
                }
                this.can_add_comment = this.can_generate_bill
                this.placeholder = (this.can_generate_bill)?'Confirmation':'Commentaire'
            })
        },

        setColspans() {
            if (cca_config.IS_SFE) {
                if (this.can_set_pac) {
                    this.colspans.colspan_1 = 13
                    this.colspans.colspan_3 = 12
                } else {
                    this.colspans.colspan_1 = 11
                    this.colspans.colspan_3 = 10
                }
            } else {
                if (this.can_set_pac) {
                    this.colspans.colspan_2 = 12
                    this.colspans.colspan_4 = 11
                } else {
                    this.colspans.colspan_2 = 10
                    this.colspans.colspan_4 = 9
                }
            }
        },

        handleOnline() {
            this.is_online = true;
            this.onReconnect();
        },

        handleOffline() {
            this.is_online = false;
        },
        
        onReconnect() {
            this.is_online = true;
        },
        
        getTypeFacturesSFE() {
            const data = {
                data_type: 'invoice_type',
                endpoint: 'invoiceTypes'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {
                this.sfe_type_facture.forEach(bill_type => {
                    if (bill_type.type === 'FV' || bill_type.type === 'EV') {
                        const tmp_aib = {
                            description: bill_type.description,
                            type: bill_type.type
                        }
                        this.type_factures.push(tmp_aib)

                        if (bill_type.type === 'FV') {
                            this.selected_type_facture = tmp_aib
                        }
                    }
                });
            })
        },

        getTypePaiementSFE() {
            const data = {
                data_type: 'payment_type',
                endpoint: 'paymentTypes'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {
                this.selected_type_paiement = this.sfe_type_paiement[0]
            })
        },

        getInsuranceInfo() {
            this.info_is_loading = true
            store_patient.getPatientInsuranceInfo(this.patient.patient_id).then((patient_insurance_info) => {
                this.patient_insurance_info = patient_insurance_info
                this.info_assurance = {
                    taux_couverture: '',
                    est_assure: patient_insurance_info.est_assure,
                    est_expire: patient_insurance_info.contrat_a_expire,
                    assurance_id: (patient_insurance_info.assur_id != null) ? patient_insurance_info.assur_id : '',
                    assurance: patient_insurance_info.assur_nom,
                    souscripteur_id: (patient_insurance_info.souscripteur_id != null) ? patient_insurance_info.souscripteur_id : '',
                    souscripteur: (patient_insurance_info.souscripteur != null) ? patient_insurance_info.souscripteur : '',
                    assure_principal_id: (patient_insurance_info.assure_principal_id != null) ? patient_insurance_info.assure_principal_id : '',
                }

                this.info_is_loading = false

                this.setColspans()
            }).catch(() => {
                this.info_error_load = true
                this.info_is_loading = false
            })
        },

        calcImpotAIB() {
            let sfe_tot = 0
            let sfe_impot = 0
            let sfe_imposable = 0
            let total_imposable_aib = 0
            let impot_aib = 0

            this.bill_selected_operations.forEach((operation) => {
                operation.prestations.forEach(prestation => {
                    let m_paye = prestation.montant_paye
                    sfe_tot += m_paye

                    // Calcul imposable
                    if (prestation.taux_taxation > 0) {
                        sfe_imposable = parseInt(sfe_imposable)
                        sfe_imposable = ( m_paye / (1 + prestation.taux_taxation/100) )
                        sfe_imposable = parseFloat(sfe_imposable).toFixed(0)
                        sfe_imposable = parseInt(sfe_imposable)

                        // Calcul impot 
                        sfe_impot += m_paye - sfe_imposable
                    }
                })
            })

            // Calcul AIB
            
            if (this.selected_sfe_aib.libelle != 'N/A') {
                total_imposable_aib += (sfe_tot - sfe_impot)
            }

            impot_aib = parseFloat((this.selected_sfe_aib.taux / 100) * total_imposable_aib).toFixed(0)
            impot_aib = parseInt(impot_aib)
            return impot_aib
        },

        setBillingOperation() {
            this.billing_operations = []
            this.tot_base_assurance = 0
            this.total_prix_assureur = 0
            this.total_prix_assure = 0
            this.total_net = 0
            let total_rate = 0
            let total_prest = 0

            this.bill_selected_operations.forEach((operation) => {
                operation.prestations.forEach(prestation => {
                    let montant = 0
                    montant = prestation.montant_paye
                    if (prestation.data_type == 'apport_social') {
                        montant = -montant
                    }

                    if (prestation.base_assurance != null) {
                        this.tot_base_assurance += (parseInt(prestation.base_assurance) * prestation.qte)
                    }
                    
                    this.total_prix_assureur += prestation.part_assureur

                    this.total_net += montant
                    this.billing_operations.push(prestation)

                    total_rate += prestation.currency_rate
                    total_prest += 1
                });
            });

            if (cca_config.IS_SFE) {
                const impot_aib = this.calcImpotAIB()
                
                if (impot_aib > 0) {
                    this.total_net += impot_aib
                }
            }
            this.total_prix_assure = this.total_net

            this.bill_currency_rate = parseInt(total_rate / total_prest)
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer(is_standardized) {
            this.is_confirm = true
            this.is_standardized = is_standardized
        },

        toggleBill() {
            this.is_confirm = false
            this.can_generate_bill = this.can_add_comment
            // let confirm = document.getElementById("confirm-bill");
            // confirm.checked = false
        },

        generateBill(selector) {
            let confirm = document.getElementById(selector);

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.save_loading = false
                return
            }

            if (this.is_standardized) {
                if (!this.is_online) {
                    return;
                }
            }
            

            const info_clinique = cca_config.NOM_CLINIQUE
            let type_aib = ''

            if (cca_config.IS_SFE) {
                if (this.selected_sfe_aib.slug != 'n_a') {
                    if (this.selected_sfe_aib.slug == 'aibA') {
                        type_aib = 'A'
                    } else if (this.selected_sfe_aib.slug == 'aibB') {
                        type_aib = 'B'
                    }
                }
            }

            const data = {
                is_standardized: this.is_standardized,
                patient_id: this.patient.patient_id,
                user_id: this.userCredentials.user.id,
                operations: this.billing_operations,
                montant: this.total_net,
                operator: {
                    "name": info_clinique
                },
                payment: {
                    "name": this.selected_type_paiement.type,
                    "amount": this.total_net
                },
                client: {
                    "ifu": this.client.ifu,
                    "name": this.client.nom_client
                },
                aib: type_aib,
                type: this.selected_type_facture.type,
                commentaire: this.commentaire,
                is_self_client: this.is_self_client,
                can_set_pac: this.can_set_pac,
                info_patient: {
                    nom_patient: this.patient.nom_patient,
                    sexe: this.patient.sexe,
                    telephone: this.patient.telephone_mobile,
                    num_dossier: this.patient.num_dossier,
                    age: this.patient.age
                },
                info_caissier: {
                    nom_caissier: this.userCredentials.user.name,
                    titre: this.userCredentials.user.titre
                }
            }

            this.save_loading = true;
            this.$store.dispatch('generateBill', data).then((response) => {
                if (response.success) {
                    this.successToast("Facture générée avec succès")

                    this.is_confirm = false
                    this.$refs.confirm_bill.click();
                    this.$router.push({ path: '/factures' })
                } else {
                    if (response.code == 500) {
                        this.warningToast("Une erreur s'est produite lors de la génération de la facture !")
                    } else if (response.code == 400) {
                        this.sfe_error = true
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.warningToast("Une erreur s'est produite !")
                this.save_loading = false
            })
        },

        printTmpBill() {
            this.tmp_bill_date = new Date()

            this.can_print = true
            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 500);
        },

        viewInfo(info_operation) {
            this.info_operation = info_operation

            setTimeout(() => {
                $('.p-info-rst-'+info_operation.id).modal('show')
            }, 500);
        },

        nextToGenBill() {
            this.info_client_is_empty = false

            if (this.is_sfe) {
                let info_client = document.getElementById('inf-client');

                if (info_client.checked == true) { 
                    if (this.client.ifu == '') {
                        this.info_client_is_empty = true
                        return;
                    } else if (this.client.nom_client == '') {
                        this.info_client_is_empty = true
                        return;
                    } else {
                        this.info_client_is_empty = false
                    }
                }
            }

            this.can_generate_bill = true
            this.placeholder = "Confirmation"
        },

        backToInfoClient() {
            this.can_generate_bill = false
            this.placeholder = "Commentaire"
        },

        handleInfoClient() {
            let info_client = document.getElementById('inf-client');

            if (!info_client.checked) { 
                this.client.ifu = ''
                this.client.nom_client = ''
                this.info_client_is_empty = false

                this.client.nom_client = ''
                document.getElementById('self').checked = false
            }
        },

        handleSelfAsClient() {
            let is_client = document.getElementById('self');

            this.is_self_client = is_client.checked
            if (is_client.checked) {
                this.client.nom_client = this.patient.nom_patient
            } else {
                this.client.nom_client = ''
            }
        },

        clearError() {
            this.info_client_is_empty = false
        }
    }
}